var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortraiticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 34,
    y: 21,
    width: 43,
    height: 68,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAABECAYAAAAY/8xPAAADeklEQVRogWIsKChIYGJi6mdgYBBgGLzgwf///xsAAAAA//9iYmJiqh/kDgUBBUZGxgkAAAAA//9iAjEGgWMIAwYGAQAAAAD//wI5dmgABgYGAAAAAP//YkF3aW9v76BxfHFxMYLDwMAAAAAA//8aOiHLwMAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//8aOo5lYGAAAAAA//9iLCoq+j8I3EEYMDAwAAAAAP//Gjohy8DAAAAAAP//Ajn2wyBwB0Hw////BwAAAAD//2L69+9fIYgxyN36gYGBoQEAAAD//wMAOF8bjYd7dBUAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortraiticon);
export default __webpack_public_path__ + "static/media/Portrait icon.f76bd87765499c42a130644252576eaf.svg";
export { ForwardRef as ReactComponent };